/*
 * <copy-email> — the email card on the contact page.
 * Markup lives in sections/hansker-contact.liquid, styles in hansker-contact.css.
 *
 * The address is always a real mailto: link, so the card still works with this
 * script blocked or the Clipboard API unavailable. In that case the copy button
 * removes itself rather than sitting there doing nothing.
 */
if (!customElements.get('copy-email')) {
  customElements.define(
    'copy-email',
    class CopyEmail extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('[data-copy-email-button]');
        this.status = this.querySelector('[data-copy-email-status]');
        this.email = this.dataset.email;
        this.copiedLabel = this.dataset.copiedLabel;

        if (!this.button) return;

        // No Clipboard API (http, ancient browser) — the mailto link is the fallback.
        if (!navigator.clipboard) {
          this.button.remove();
          return;
        }

        this.defaultLabel = this.button.textContent.trim();
        this.resetTimer = null;
        this.button.addEventListener('click', this.copy.bind(this));
      }

      copy() {
        navigator.clipboard.writeText(this.email).then(
          () => this.confirm(),
          () => this.confirm(true)
        );
      }

      /* Swaps the button label and announces the result to screen readers.
         Both paths land here so a blocked clipboard still says something. */
      confirm(failed) {
        const message = failed ? this.email : this.copiedLabel;

        this.button.textContent = message;
        this.button.classList.add('hnsk-contact__copy--copied');

        if (this.status) this.status.textContent = message;

        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => {
          this.button.textContent = this.defaultLabel;
          this.button.classList.remove('hnsk-contact__copy--copied');
          if (this.status) this.status.textContent = '';
        }, 2400);
      }
    }
  );
}
